import React, { useCallback, useEffect, useRef, useState } from 'react';
import SvgCom from '../../components/SvgCom/index.jsx';
import { ReactComponent  as LeftArrowSvg } from '../../assets/svgs/left_arrow.svg';
import { ReactComponent  as ReorderSvg } from '../../assets/svgs/reorder.svg';
import { ReactComponent  as GenerateSvg } from '../../assets/svgs/generate.svg';
import { ReactComponent  as ChangeOrderSvg } from '../../assets/svgs/change_order.svg';
// import { ReactComponent as EditSvg } from '../../assets/svgs/edit.svg';
import { ReactComponent as MoreSvg } from '../../assets/svgs/more.svg';
import { ReactComponent as DeleteSvg } from '../../assets/svgs/delete.svg';
import { ReactComponent as DownloadSvg } from '../../assets/svgs/download.svg';
// import { ReactComponent as SwitchSvg } from '../../assets/svgs/switch.svg';
import { ReactComponent as CopySvg } from '../../assets/svgs/copy.svg';
import { ReactComponent as AddSvg } from '../../assets/svgs/add.svg';
import musicIcon from '../../assets/images/music.png';
import musicActiveIcon from '../../assets/images/music_active.png';
// import bgIcon from '../../assets/bg.png';
import CardCom from '../../components/CardCom/index.jsx';
import { Dropdown, message, Modal, Slider, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { createShowreelVideo, deleteShowreelItem, getShowreelDetail, putShowreel } from '../../api/request.js';
import moment from 'moment';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { copyToClipboard } from '../../utils/utils.js';
import UploadSlideWinCom from './components/UploadWinCom.jsx';

const ShowreelDetailPage = () => {
  const navigate = useNavigate();
  const showreelId = useParams().showreelId;
  const [loading, setLoading] = useState(false);
  const [detailInfo, setDetailInfo] = useState({});
  const videoRef = useRef(null);
  const [duration, setDuration] = useState('00:00');
  const [showWin, setShowWin] = useState(false);

  const [ musicbg, setMusicbg ] = useState(false);
  const [ musicVolume, setMusicVolume ] = useState(0.5);

  const [newSlide, setNewSlide] = useState({});
  const dropdownList = [
    {
      key: '1',
      label: 'Download showreel item',
      icon: <SvgCom Svg={DownloadSvg} size='14' className='text-grey-3'></SvgCom>
    },
    // {
    //   key: '2',
    //   label: 'Reorder',
    //   icon: <SvgCom Svg={SwitchSvg} size='14' className='text-grey-3'></SvgCom>
    // },
    {
      key: '3',
      label: 'Copy',
      icon: <SvgCom Svg={CopySvg} size='14' className='text-grey-3 opacity-100' fill-opacity='1'></SvgCom>
    },
    {
      key: '4',
      label: 'Add slide above',
      icon: <SvgCom Svg={AddSvg} size='14' className='text-grey-3'></SvgCom>
    },
    {
      key: '5',
      label: 'Add slide below',
      icon: <SvgCom Svg={AddSvg} size='14' className='text-grey-3'></SvgCom>
    },
  ];

  const fnMenuChange = async({key}, clipItem) => {
    if(key ==='3') {
      await copyToClipboard(clipItem.clip.content);
      message.success('Copid');
    }
    if(key === '4' || key === '5') {
      const { id, showreel } = clipItem;
      let tempSlide = {
        id: showreel,
        extra_video_path: '',
        target_id: id,
        position: 1
      };
      if(key === '4') {
        tempSlide.position = 1;
      } else {
        tempSlide.position = -1;
      }
      setNewSlide(tempSlide);
      setShowWin(true);
    }
  };

  const getDetail = useCallback(async() => {
    if(!showreelId) return;
    try {
      setLoading(true);
      const result = await getShowreelDetail(showreelId);
      if(result.status === 'Success') {
        setDetailInfo(result.data);
      } else {
        throw new Error(result?.message || 'service error');
      }
    } catch(error) {
      message.error(error?.message || error?.msg || 'service error');
    } finally {
      setLoading(false);
    }
  }, [showreelId]);

  useEffect(() => {
    getDetail();
  }, [getDetail]);

  useEffect(() => {
    const fnTest = () => {
      const seconds = videoRef.current.duration;
      const timerStr = moment.utc(seconds * 1000).format('HH:mm:ss');
      setDuration(timerStr);
    };
    if(videoRef && videoRef.current) {
      videoRef.current.addEventListener('loadedmetadata', fnTest);
    }
    return () => {
      if(videoRef.current) {
        videoRef.current.removeEventListener('loadedmetadata', fnTest);
      }
    };
  }, [videoRef]);

  const [showeelList, setShoweelList] = useState([]);
  useEffect(() => {
    const tempList = [...(detailInfo?.items || [])];
    setShoweelList(tempList);
  }, [detailInfo]);

  // drag drop
  const dragableBoxRef = useRef(null);
  useEffect(() => {
    let curIndex = -1;
    let targetIndex = -1;
    const fnDragstart = (e) => {
      e.target.classList.add('cur-dragable');
      curIndex = e.target.dataset.flag;
    };

    const fnDragend = async (e) => {
      e.target.classList.remove('cur-dragable');
      const eleList = document.querySelectorAll('.cur-dragable-selected');
      if(eleList.length) {
        for(let i=0;i < eleList.length; i++) {
          eleList[i].classList.remove('cur-dragable-selected');
        }
      }
      // 切换位置
      if(targetIndex !== -1) {
        const tempList = [...showeelList];
        if(curIndex == targetIndex) return;
        if(curIndex > targetIndex) {
          const curEle = tempList.splice(curIndex, 1)[0];
          tempList.splice(targetIndex, 0, curEle);
        } else if(curIndex < targetIndex) {
          if(targetIndex - 1 == curIndex) {
            return;
          }
          const curEle = tempList.splice(curIndex, 1)[0];
          tempList.splice(targetIndex - 1, 0, curEle);
        }
        setShoweelList(tempList);
        // try {
        //   const result = await putShowreelSort(curEle.showreel, curEle.id, targetIndex);
        //   if(result.status === 'Success') {
        //     message.success('Sorting is complete.');
        //   }
        // } catch(error) {
        //   //
        // }
      }
    };

    const fnDragover = (e) => {
      e.preventDefault();
      let curTarget = e.target;
      if(curTarget.dataset?.flag) {
        //
      } else {
        let parent = curTarget.parentNode;
        while (parent) {
          if (parent.dataset?.flag) {
            curTarget = parent;
            break;
          }
          parent = parent.parentNode;
        }
      }
      const eleList = document.querySelectorAll('.cur-dragable-selected');
      if(eleList.length) {
        for(let i=0;i < eleList.length; i++) {
          eleList[i].classList.remove('cur-dragable-selected');
        }
      }
      curTarget.classList.add('cur-dragable-selected');

      const curTargetFlag = curTarget.dataset.flag;
      if(curTargetFlag != curIndex) {
        targetIndex = curTargetFlag;
      } else {
        targetIndex = -1;
      }
    };

    if(dragableBoxRef && dragableBoxRef.current) {
      dragableBoxRef.current.addEventListener('dragstart', fnDragstart);
      dragableBoxRef.current.addEventListener('dragend', fnDragend);
      dragableBoxRef.current.addEventListener('dragover', fnDragover);
    }
    return ()=> {
      if(dragableBoxRef && dragableBoxRef.current) {
        dragableBoxRef.current.removeEventListener('dragstart', fnDragstart);
        dragableBoxRef.current.removeEventListener('dragend', fnDragend);
        dragableBoxRef.current.removeEventListener('dragover', fnDragover);
      }
    };
  }, [dragableBoxRef, showeelList]);

  // delete showreel item
  const fnDeleteShowreelItem = (showreelId, itemId) => {
    Modal.confirm({
      title: 'Warning',
      icon: <ExclamationCircleOutlined />,
      content: 'Do you want to delete this record?',
      okText: 'Entry',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await deleteShowreelItem(showreelId, itemId);
          getDetail();
        } catch(error) {
          //
        } finally {
          //
        }
      }
    });
  };

  const fnGenerateShowreel = async () => {
    try {
      const params = {
        'background_music': musicbg,
        'background_music_volume': musicVolume,
      };
      const result = await createShowreelVideo(detailInfo.id, params);
      if(result.status === 'Success') {
        message.info('Your request has been submitted. Please wait.');
      }
    } catch(error) {
      //
    } finally {
      //
    }
  };

  const fnDownloadVideo = async () => {
    const link = document.createElement('a');
    link.href = detailInfo?.video_url;
    link.download = true;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onResetSort = async () => {
    const ids = showeelList.map(item => item.id);
    const result = await putShowreel(showreelId, {
      sort_orders: ids
    });
    if(result.status === 'Success') {
      message.success('Sorting is complete.');
    }
  };

  return (
    <Spin spinning={loading} size='large' tip="Loading...">
      <div className="px-[30px] py-[30px]">
        <div onClick={() => navigate(-1)} className="text-primary w-fit flex justify-start items-center mb-[22px] cursor-pointer">
          <SvgCom Svg={LeftArrowSvg} size="16"></SvgCom>
          <span className="text-base leading-none font-semibold ml-2">Go Back Showreel</span>
        </div>
        <div className='flex justify-start mb-[40px]'>
          <div>
            <video ref={videoRef} className="w-[350px] h-[320px] bg-black" autoPlay={false} muted loop controls src={detailInfo?.video_url} preload="true"></video>
          </div>
          <div className='ml-4 flex-1 flex flex-col justify-start'>
            <div className='text-[24px] font-bold leading-none text-primary'>{detailInfo?.title}</div>
            <div className='flex justify-start items-center text-[#B9C5B5] text-[12px] leading-none font-semibold mt-3'>
              <span>Created: {moment(detailInfo?.created_at).format('YYYY/MM/DD')}</span>
              {/* <span className='ml-3'>View: {detailInfo?.items_count}</span> */}
            </div>
            <div className="h-[1px] bg-second my-3"></div>
            <div className='text-[12px] leading-none font-normal text-green-1'>
              <div className='flex items-center justify-start mb-3'>
                <div className='mr-2'>Duration: {duration}</div>
                <img src={musicbg ? musicActiveIcon : musicIcon} onClick={() => setMusicbg(!musicbg)} className='w-4 h-4 ml-2 cursor-pointer' alt="" />
                <Slider onChange={(value) => setMusicVolume(value)} defaultValue={0.5} value={musicVolume} step={0.01} className='ml-5 w-[100px]' min={0} max={1} />
              </div>
              <div className='mb-3'>Clips: {detailInfo?.items_count}</div>
              {/* <div className=''>Slides: 4</div> */}
            </div>
            <div className='flex justify-start items-center mt-5'>
              <button onClick={onResetSort} className='flex items-center py-[10px] px-[15px] rounded-[30px] border-2 border-primary text-primary text-[14px] leading-none font-semibold'>
                <SvgCom Svg={ReorderSvg} className='w-4 h-4'></SvgCom>
                <span className='ml-2'>Confirm Reorder</span>
              </button>

              <button onClick={fnGenerateShowreel} className='ml-5 flex items-center py-[10px] px-[15px] rounded-[30px] border-2 border-second text-primary bg-second text-[14px] leading-none font-semibold'>
                <SvgCom Svg={GenerateSvg} className='w-4 h-4'></SvgCom>
                <span className='ml-2'>Generate showreel</span>
              </button>

              <button onClick={fnDownloadVideo} className='ml-5 flex items-center py-[10px] px-[15px] rounded-[30px] border-2 border-second text-primary bg-second text-[14px] leading-none font-semibold'>
                <SvgCom Svg={DownloadSvg} className='w-4 h-4'></SvgCom>
                <span className='ml-2'>Download</span>
              </button>
            </div>
            <div className='flex-1'></div>
            {/* <div className='text-[12px] leading-none font-normal text-green-1 mb-3'>Recently Generated showeels</div>
            <div className='flex justify-start items-center'>
              <img src={bgIcon} className='w-[60px] h-[60px] rounded-[9px] mr-2' alt=''></img>
              <img src={bgIcon} className='w-[60px] h-[60px] rounded-[9px] mr-2' alt=''></img>
              <img src={bgIcon} className='w-[60px] h-[60px] rounded-[9px] mr-2' alt=''></img>
            </div> */}
          </div>
        </div>
        <CardCom label="Showreel" className='[&>div.card-content]:!p-0'>
          <div className='ctp-dragable' ref={dragableBoxRef}>
            <div className='h-[1px]'></div>
            {
              showeelList.map((item, index) =>
                <div key={index} draggable className='px-5 my-5 relative' data-flag={index}>
                  <div className='flex justify-start my-[10px]'>
                    <div className='flex flex-col items-center justify-center w-[30px]'>
                      <div className='flex justify-center items-center w-full h-[24px] leading-none rounded-[6px] text-[12px] font-semibold text-white bg-primary'>
                        {item.sort_order}
                      </div>
                    </div>
                    <div className='mx-5 w-[110px] h-[110px] flex justify-center items-center'>
                      {/* <img src={bgIcon} className='w-[110px] h-[110px] rounded' alt="" /> */}
                      <SvgCom Svg={ChangeOrderSvg} className='w-7 h-7'></SvgCom>
                    </div>
                    <div className='flex-1 flex flex-col justify-start'>
                      <div className='flex justify-between items-center'>
                        <span className='text-[16px] font-bold leading-none text-primary'>Item{index + 1}</span>
                        <div className='flex items-center'>
                          {/* <SvgCom Svg={EditSvg} size="16" className="cursor-pointer hover:text-green-1 text-primary"></SvgCom> */}
                          <Dropdown
                            menu={{
                              items: dropdownList,
                              onClick: (menuInfo) =>  fnMenuChange(menuInfo, item)
                            }}
                          >
                            <SvgCom Svg={MoreSvg} size="16" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>
                          </Dropdown>
                        </div>
                      </div>
                      <p className='text-[14px] leading-[20px] text-primary font-normal mt-5 flex-1'>
                        {item.clip?.content}
                      </p>
                      <div className='flex justify-between'>
                        <div></div>
                        <SvgCom onClick={() => fnDeleteShowreelItem(item.showreel, item.id)} Svg={DeleteSvg} size="22" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
            <div className='h-[20px] w-full relative' data-flag={showeelList.length}></div>
          </div>
        </CardCom>
        
      </div>

      <UploadSlideWinCom showWin={showWin} onCloseWin={setShowWin} newSlide={newSlide} onRefresh={getDetail}></UploadSlideWinCom>
    </Spin>
  );
};

export default ShowreelDetailPage;